// removed by extract-text-webpack-plugin
    if(module.hot) {
      // 1784550829644
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  


//////////////////
// WEBPACK FOOTER
// ./src/containers/DefaultLayout/logo.scss
// module id = ./src/containers/DefaultLayout/logo.scss
// module chunks = 6